var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9981 6C11.9981 9.31371 9.31219 12 5.99893 12C2.68568 12 -0.000244141 9.31371 -0.000244141 6C-0.000244141 2.68629 2.68568 0 5.99893 0C9.31219 0 11.9981 2.68629 11.9981 6ZM5.24904 6.5C5.24904 6.91421 5.58478 7.25 5.99893 7.25C6.41309 7.25 6.74883 6.91421 6.74883 6.5V3C6.74883 2.58579 6.41309 2.25 5.99893 2.25C5.58478 2.25 5.24904 2.58579 5.24904 3V6.5ZM5.24904 9C5.24904 9.41421 5.58478 9.75 5.99893 9.75C6.41309 9.75 6.74883 9.41421 6.74883 9C6.74883 8.58579 6.41309 8.25 5.99893 8.25C5.58478 8.25 5.24904 8.58579 5.24904 9Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamationMark.33892c5f6df77b0767cf20f54a023f72.svg";
export { ForwardRef as ReactComponent };